import PerfectScrollbar from 'perfect-scrollbar';


export default ({ y = true, x = false, children }) => {
	
	const id = `scrollable-${ new Date().getTime() }`;
	
	React.useEffect(() => {
		new PerfectScrollbar( document.getElementById(id) );
	}, []);
	
	const className = (() => {
		if( y && x ) {
			return 'scrollable';
		}
		if( x ) {
			return 'scrollable-x';
		}
		if( y ) {
			return 'scrollable-y';
		}
		return 'scrollable-no';
	})();
	
	return (
		<div id={ id } className={ `scrollview ${className}` }>
			{ children }
		</div>
	);
}